import React from 'react';

export type TimelineDragState = {
  isDraggingOnMainTimeline: boolean;
  isDraggingOnMiniMap: boolean;
  isPointerDownOnMainTimeline: boolean;
  isPointerDownOnMiniMap: boolean;
};

export default function useTimelineDrag() {
  const [dragState, setDragState] = React.useState<TimelineDragState>({
    isPointerDownOnMainTimeline: false,
    isPointerDownOnMiniMap: false,
    isDraggingOnMainTimeline: false,
    isDraggingOnMiniMap: false,
  });

  const updateDragState = (partialState: Partial<TimelineDragState>) => {
    setDragState((prev) => ({ ...prev, ...partialState }));
  };

  return [dragState, updateDragState] as const;
}

export type UseTimelineDrag = ReturnType<typeof useTimelineDrag>;
